var render = function render(_c,_vm){return _c('div',[(
      _vm.$options.formatDate(_vm.props.row[_vm.props.column]) && _vm.props.column != 'Date'
    )?_c('span',{style:({
      color: _vm.$options.colorDate(_vm.props.row[_vm.props.column]) ? 'inherit' : 'red'
    })},[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.$options.setFormatDate(_vm.props))+" ")]):_vm._e(),(_vm.props.column == 'Date')?_c('span',{style:({
      color: _vm.$options.colorHour(_vm.props.row[_vm.props.column]) ? 'blue' : 'orange'
    })},[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.$options.setFormatDate(_vm.props))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }